/**
 * Sanitizes key based on GPT documentation
 * @param  {string} value Unsanitized key
 * @return {string}       Sanitized key
 */
export function sanitizeKey(value) {
  /* eslint-disable no-useless-escape */
  return value
    .replace(/[ -]/g, '_')
    .replace(/[\"\'\,\=\!\+\#\*\~\;\^\(\)\<\>\[\]]/g, '') // As per GPT docs
    .toLowerCase();
/* eslint-enable no-useless-escape */
}

/**
 * Sanitizes value based on GPT documentation
 * @param  {string} value Unsanitized value
 * @return {string}       Sanitized value
 */
export function sanitizeValue(value, replaceDashes = false) {
  /* eslint-disable no-useless-escape */
  let output = value.replace(/[\"\'\,\=\!\+\#\*\~\;\^\(\)\<\>\[\]]/g, ''); // As per GPT docs
  if (replaceDashes) output = output.replace(/-/g, '_');
  return output;
  /* eslint-enable no-useless-escape */
}
